import { useEffect, useState } from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import { useTargetUser } from 'hooks';
import { useStyles } from './style';
import { Icons } from 'components';
import { getQuery } from 'utility';
import { useLocation } from 'react-router-dom';

export default function TargetUser({ hint }) {
  const targetUser = useTargetUser();
  const classes = useStyles();
  const location = useLocation();
  const [urlQuery, setUrlQuery] = useState(null);

  useEffect(() => {
    let result = getQuery(location);
    setUrlQuery(result)
  }, [location]);

  return targetUser?.userId ? (
    <Grid container>
      <Grid xs={12} md={6} item spacing={2}>
        <Paper className={classes.targetUser}>
          <Typography className={classes.targetTitle}>{hint}</Typography>
          <Grid container className={classes.targetContainer}>
            <Grid item>
              <img
                alt={targetUser?.fullName ?? 'پروفایل کاربر'}
                src={targetUser?.image ?? './images/profile.png'}
                className={classes.profileImage}
              />
            </Grid>
            <Grid item>


              <Typography className={classes.targetFullName}>
                {urlQuery?.isReport === 'true' ? (urlQuery?.firstName + ' ' + urlQuery?.lastName) : targetUser?.fullName ? targetUser?.fullName : '-'}
              </Typography>
              {urlQuery?.isReport !== 'true' && (
                <Typography className={classes.targetUsername}>
                  {targetUser?.username ?? '-'}
                </Typography>
              )}

              <Typography className={classes.targetId}>
                شناسه کاربر :‌ {` ${targetUser?.userId}` ?? '-'}
              </Typography>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  ) : null;
}
